import { useChatStore } from '../store/chat'

interface ChatFloatingButtonProps {
  onClick: () => void
}

export default function ChatFloatingButton({ onClick }: ChatFloatingButtonProps) {
  const { loading, streamingContent } = useChatStore()
  const isProcessing = loading || !!streamingContent

  return (
    <button
      onClick={onClick}
      className={`
        fixed bottom-6 right-6 z-40
        w-14 h-14 rounded-full
        flex items-center justify-center
        text-2xl
        shadow-lg shadow-indigo-500/30
        transition-all duration-200 ease-out
        hover:scale-110 hover:shadow-xl hover:shadow-indigo-500/40
        active:scale-95
        ${isProcessing 
          ? 'bg-gradient-to-r from-indigo-500 to-purple-600 animate-pulse' 
          : 'bg-gradient-to-r from-indigo-600 to-purple-700 hover:from-indigo-500 hover:to-purple-600'
        }
      `}
      style={{
        boxShadow: isProcessing 
          ? '0 0 20px rgba(99, 102, 241, 0.6), 0 10px 25px -5px rgba(99, 102, 241, 0.4)'
          : '0 10px 25px -5px rgba(79, 70, 229, 0.4), 0 8px 10px -6px rgba(79, 70, 229, 0.3)'
      }}
      aria-label="Avaa AI-chat"
      title="AI-chat (Cmd+K)"
    >
      <span className={isProcessing ? 'animate-bounce' : ''}>
        {isProcessing ? '💬' : '🤖'}
      </span>
      
      {/* Ripple effect ring when processing */}
      {isProcessing && (
        <span className="absolute inset-0 rounded-full border-2 border-white/30 animate-ping" />
      )}
      
      {/* Glow effect */}
      <span className="absolute inset-0 rounded-full bg-gradient-to-r from-white/20 to-transparent opacity-0 hover:opacity-100 transition-opacity duration-200" />
    </button>
  )
}
